"use client";

import type { ReactNode } from "react";

import * as NavigationMenu from "@radix-ui/react-navigation-menu";
import clsx from "clsx";
import Image from "next/image";
import { useState } from "react";

import type { NavigationItem } from "@/src/components/navigation/NavigationItems";

import { LegacyUrl, legacyUrls } from "@/src/app/legacyUrls";
import { brandName } from "@/src/app/metadata";
import { NavigationItems } from "@/src/components/navigation/NavigationItems";

interface NavigationProps {
  readonly consumerItems: NavigationItem[];
  readonly societaireItems: NavigationItem[];
}

export function Navigation({
  consumerItems,
  societaireItems,
}: NavigationProps): ReactNode {
  const [value, setValue] = useState("");
  return (
    <NavigationMenu.Root
      className={clsx(
        "bg-primary sticky top-0 z-50 min-h-14 text-white",
        "print:hidden",
      )}
      onValueChange={setValue}
      value={value}
    >
      <div className="relative flex min-h-full w-full basis-52 items-center justify-between text-white">
        <NavigationMenu.Link asChild>
          <a
            className={clsx(
              "flex h-14 items-center px-3 transition-all",
              "hover:bg-primary-hover hover:rounded-br",
            )}
            href={legacyUrls[LegacyUrl.accueil]}
          >
            <Image
              alt={brandName}
              fetchPriority="high"
              height={34}
              preload
              src="/logos/cqlp-white-inline.svg"
              width={133}
            />
          </a>
        </NavigationMenu.Link>
        <NavigationItems
          consumerItems={consumerItems}
          opened={value !== ""}
          societaireItems={societaireItems}
        />
      </div>
    </NavigationMenu.Root>
  );
}
